import axios from 'axios'

// 获取默认语列表
export function queryEvaluateSetPage (datas) {
  const url = `/ImDefaultSpeech/queryImDefaultSpeechPage`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取默认语列表
export function ImDefaultSpeech (datas) {
  const url = `/ImDefaultSpeech/batchUpdate`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/default/index.js